<template>
  <li
    class="mobile-nav__item"
    role="none"
    :class="{
      'has-sub': hasChildren,
    }"
  >
    <MegaMenuItemLink
      class="mobile-nav__link"
      label-class="mobile-nav__link-label"
      post-icon-class="mobile-nav__link-icon"
      :item="item"
      :has-drop="hasChildren"
      :aria-haspopup="hasChildren"
      :route="route"
      role="menuitem"
      tabindex="0"
      @link-click="onParentClick"
    />
    <template v-if="hasChildren">
      <mobile-menu-item-drop
        v-show="layoutNavStore.openedNavItem === item"
        :item="item"
        class="mobile-nav__sub"
        @link-click="onLinkClick"
        @close="close"
      />
    </template>
  </li>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useLayoutNavStore } from '@/stores/layout-nav';
import MegaMenuItemLink from '~/components/ui/layout/mega-menu/MegaMenuItemLink.vue';
import MobileMenuItemDrop from '~/components/ui/layout/mobile-menu/MobileMenuItemDrop.vue';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  route: {
    type: Object,
    default: null,
  },
});

const layoutNavStore = useLayoutNavStore();
const hasChildren = computed(() => {
  return Array.isArray(props.item.child_links) && props.item.child_links.length > 0;
});

const onParentClick = (ev) => {
  if (hasChildren.value) {
    ev.preventDefault();
    layoutNavStore.toggleOpenedNavItem(props.item);
  } else {
    layoutNavStore.toggleNavOverlay(false);
  }
};

const onLinkClick = () => {
  close();
};

const close = () => {
  if (layoutNavStore.navOverlayOpen) {
    layoutNavStore.toggleNavOverlay(false);
    layoutNavStore.toggleOpenedNavItem(null);
  }
};
</script>
